export default {
  reasons: [],
  reason: undefined,
};
